import PlaybookDebugger from '../playbook';
import { useRef, useState } from "react";
import { useParams } from "react-router";
import { connect } from "react-redux";
import { ReactFlowProvider } from "reactflow";
import { useAppInfo } from "../../../helpers/hooks/common-hook";
import { stmNodeSelect } from "../../../redux/journey-toolbox/journey-toolbox-actions";

import JourneyFlow from "./journey/journey-flow";

// Custome stylesheet
import "reactflow/dist/style.css";
import "./index.css";
import SectionHeading from "../section-heading";
import WorkflowCanvas from "../../../components/workflow/WorkflowCanvas";
import {useEffect} from "react";
// import {useContext} from "@types/react";
// import {WorkflowCanvasContext} from "../../../contexts/WorkflowCanvasContextProvider";

function Page({
                currentJourneyConfig,
                currentJourneySession
}) {
  if (currentJourneyConfig?.stm?.metadata?.playbook) {
    return <PlaybookDebugger key={`${currentJourneySession?.sessionId}:${currentJourneySession?.journeyId}`} config={currentJourneyConfig} session={currentJourneySession} />;
  }
  return <div className="flex min-h-0 min-w-0 flex-1 flex-col">
    {/* TOP */}
    <SectionHeading title="Workflow" subtitle={currentJourneyConfig.name || "Execution flow"} />

    {/* CONTENT */}
    <div className="min-h-0 flex-1 relative bg-gray-50/60 overflow-hidden [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      <ReactFlowProvider>
        <WorkflowCanvas
            key={currentJourneySession?.sessionId}
            journeyId={currentJourneySession?.journeyId}
            currentJourneySession={currentJourneySession}
            currentJourneyConfig={currentJourneyConfig}
            isPreview={true}
        />
      </ReactFlowProvider>
    </div>
  </div>
}

const mapsStateToProps = (state, ownProps) => {
  return {
    journeyToolboxItemAddMessage: state.journeyToolboxItemAddMessage,
    stmNodeSelectMessage: state.stmNodeSelectMessage,
    stmEdgeAddMessage: state.stmEdgeAddMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    stmNodeSelectHandle: (message) => {
      dispatch(stmNodeSelect(message));
    },
  };
};

export default connect(mapsStateToProps, mapDispatchToProps)(Page);
